<template>
  <div>
    <van-nav-bar
      title="新闻资讯"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-skeleton title avatar :row="4" :loading="loading">
        <van-swipe-item v-for="(item, index) in swiperList" :key="index">
          <van-image width="100%" :src="item.img">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
            <template v-slot:error>加载失败</template>
          </van-image>
        </van-swipe-item>
      </van-skeleton>
    </van-swipe>
    <van-list
      v-model="loadingNews"
      :finished="finishedNews"
      finished-text="没有更多了"
      @load="getNews"
    >
      <div
        style="padding: 0px 10px"
        v-for="(item, index) in list"
        :key="index"
        @click="goDetails(item.id)"
      >
          <van-row class="contentStyle">
            <van-col span="8" style="padding-left: 10px">
              <img
                :src="$store.state.login_logo_url"
                width="100%"
                v-if="$store.state.login_logo_url"
                style="width: 70px"
              />
              <img
                :src="
                  require('../assets/images/' + $store.state.login_logo_img)
                "
                width="100%"
                v-if="!$store.state.login_logo_url"
                style="width: 70px"
              />
              <!-- <img src="../assets/images/logo.jpg" style="width: 70px" /> -->
            </van-col>
            <van-col span="16" style="text-align: left; padding-right: 10px">
              <van-row style="padding-top: 10px; color: #000000"
                ><span>{{ item.title }}</span></van-row
              >
              <!-- <van-row style="padding-top: 10px; color: #646566"
              ><van-col span="22">
                <span
                  ></span
                >
              </van-col>
              <van-col span="2"> </van-col>
            </van-row> -->
              <van-row class="dateDesign"
                ><span>{{ item.time }}</span></van-row
              >
            </van-col>
          </van-row>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "NewsInfo",
  data() {
    return {
      list: [],
      swiperList: [],
      loading: false,
      finished: false,
      loadingNews: false,
      finishedNews: false,
      page: 1,
    };
  },
  methods: {
    goBack(){
window.history.back();
    },
    getInfoData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "home",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code === 1) {
            that.swiperList = resData.data.banner;
            that.loading = false;
          } else if (resData.code === 0) {
            that.$notify({ type: "warning", message: resData.msg });
          }
        })
        .finally(() => {
          that.loading = false;
          that.finished = true;
        });
    },
    getNews() {
      let that = this;
      let page = that.page;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "news",
            number: 20,
            page: page,
            category:sessionStorage.getItem("newsCatId")
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            let list = that.list;
            that.page = page + 1;
            that.list = list.concat(resData.data.data.data);
            that.loadingNews = false;
            if (resData.data.data.data.length < 20) {
              that.finishedNews = true;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingNews = false;
          that.finishedNews = true;
        });
    },
    goDetails(nid) {
      window.sessionStorage.setItem("nid", nid);
      this.$router.push({
        path: "/news_info_detailed",
      });
    },
  },
  mounted: function () {
    this.getInfoData();
  },
};
</script>

<style scoped>
.contentStyle {
  padding: 10px 0px;
  border-bottom: 1px solid #dcdee0;
}

.dateDesign {
  padding-top: 10px;
  color: #646566;
  font-size: 14px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsInfo.vue